import React, {Component} from 'react';
import {connect} from 'react-redux';
import isEmpty from 'is-empty';
import compressImage from '../../../utils/compress-image';

import {submitTradeSupportingDocument} from '../actions.js';

import FileInputButton from '../../shared/components/forms/FileInputButton';

class TradeSupportingDocumentSelectFiles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      attachment_files: [],
    };
  }

  sendData = () => {
    let formData = new FormData();

    this.state.attachment_files.forEach((file, index) => {
      formData.append(
        'trade_supporting_document[trade_supporting_attachments_attributes[][attachment_file]]',
        file,
        file.name,
      );
    });

    this.props.dispatch(
      submitTradeSupportingDocument(
        this.props.user_id,
        this.props.tradeDocumentType,
        this.props.tradeDocumentID,
        formData,
        () => {
          this.props.toggleProcessingAttachments();
        },
      ),
    );
  };

  uploadButtonText = () => {
    if (this.props.trade_supporting_documents.length >= 1) return 'Add Another';

    return 'Add';
  };

  onChange = e => {
    let target = e.target;

    const newFiles = Array.from(target.files);

    if (isEmpty(newFiles)) return;

    const promises = newFiles.map(file => {
      return compressImage(file);
    });

    this.props.toggleProcessingAttachments();

    this.setState(
      {
        errors: {...this.state.errors, attachment_file: ''},
      },
      () => {
        Promise.all(promises)
          .then(compressedImages => {
            this.setState({attachment_files: compressedImages}, () => {
              this.sendData();
            });
          })
          .catch(err => {
            let errors = {...this.state.errors, attachment_file: err.message};

            this.props.toggleProcessingAttachments();
            this.setState({errors: errors});
          });
      },
    );
  };

  render() {
    return (
      <section className="cardSection _simple _withColumns _noMinHeight --micro">
        <div className="text _noPadding _widthAuto">
          <p className="byline">
            Add supporting document(s) for this transaction
          </p>
        </div>
        <FileInputButton
          className="--micro -success _widthAuto"
          name="trade_supporting_document[trade_supporting_attachments_attributes[][attachment_file]]"
          error={this.state.errors.attachment_file}
          accept="image/*,application/pdf"
          buttonText={this.uploadButtonText()}
          onChange={this.onChange}
          onClick={this.props.onClickFileInput}
          dataTestId='file-input-supporting-docs'
          ref="upload_attachments"
        />
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    user_id: state.user.id,
    trade_supporting_documents: state.trade_supporting_documents,
  };
};

export default connect(mapStateToProps)(TradeSupportingDocumentSelectFiles);



// WEBPACK FOOTER //
// ./src/features/supporting_documents/containers/SelectFiles.js